import { createStore } from "vuex";
import { VuexOidcState } from "vuex-oidc";
import { IAppState } from "@/core/store/modules/app-module";
import { ICDIdentityState } from "@/core/store/modules/cd-identity-module";
import createPersistedState from "vuex-persistedstate";

export interface IRootState {
  app: IAppState;
  cdIdentity: ICDIdentityState;
  oidcStore: VuexOidcState;
}

export const store = createStore<IRootState>({
  plugins: [
    createPersistedState({
      paths: ["cdIdentity"]
    })
  ]
});

export default store;
